import { useState } from "react";

function Navbar({ activeTab, setActiveTab }) {
  const tabs = [
    { key: "policy", label: "AML Policy" },
    { key: "procedures", label: "AML Procedures" },
    { key: "screening", label: "Onboarding & Screening" },
    // { key: "onboarding", label: "Customer Onboarding" },  // ← NEW TAB ADDED
    { key: "governance", label: "Governance & Reporting" },
    { key: "record", label: "Record Keeping" }
  ];

  return (
    <nav
      style={{
        display: "flex",
        background: "white",
        padding: "10px 20px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key)}
          style={{
            flex: 1,
            padding: "12px",
            margin: "0 5px",
            border: "none",
            borderBottom:
              activeTab === tab.key
                ? "3px solid #0d47a1"
                : "3px solid transparent",
            background: "none",
            cursor: "pointer",
            fontWeight: activeTab === tab.key ? "bold" : "normal",
            color: activeTab === tab.key ? "#0d47a1" : "#555",
            transition: "0.2s",
          }}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}

export default Navbar;